import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import './PaymentSuccessPage.css';

export default function PaymentSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        navigate('/pricing');
        return;
      }

      // Wait a bit for webhook to process
      await new Promise(resolve => setTimeout(resolve, 3000));
      
      // Refresh user data to get updated premium status
      await refreshUser();
      setLoading(false);
    };

    verifyPayment();
  }, [searchParams, refreshUser, navigate]);

  const handleContinue = () => {
    navigate('/profile');
  };

  if (loading) {
    return (
      <div className="payment-success-page">
        <div className="success-container loading">
          <div className="loading-spinner"></div>
          <p>{t('payment.processing')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-success-page">
      <div className="success-container">
        <div className="success-icon">
          <CheckCircle size={80} />
        </div>
        
        <h1 className="success-title">{t('payment.success_title')}</h1>
        <p className="success-message">{t('payment.success_message')}</p>
        
        <div className="success-features">
          <h3>{t('payment.whats_next')}</h3>
          <ul>
            <li>✅ {t('payment.feature_unlocked_1')}</li>
            <li>✅ {t('payment.feature_unlocked_2')}</li>
            <li>✅ {t('payment.feature_unlocked_3')}</li>
            <li>✅ {t('payment.feature_unlocked_4')}</li>
          </ul>
        </div>

        <button onClick={handleContinue} className="continue-btn">
          {t('payment.go_to_profile')}
        </button>

        <p className="success-note">
          {t('payment.confirmation_email')}
        </p>
      </div>
    </div>
  );
}
